import initialState from "../initialState";

import { CONFIG_ACTIONS } from "./actions";

const configurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_ACTIONS.LOAD:
      const { config } = action.payload;

      return config;
    case CONFIG_ACTIONS.LOAD_MB:
      const { messageBundles } = action.payload;

      return messageBundles;
    default:
      return state;
  }
};

export default configurationReducer;
